import { useEffect, useState } from "react";
import { Carousel, Modal } from "react-bootstrap";
import { LuUser, LuUserPlus } from "react-icons/lu";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as actions from "./redux/LandingPageAction";

export const Es51LandingPage = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [selectedInbox, setSelectedInbox] = useState(null);

    const handleInboxClick = (inbox) => {
        setSelectedInbox(inbox);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const landingPageState = useSelector(
        ({ landingPage }) => landingPage,
        shallowEqual
    );

    useEffect(() => {
        dispatch(
            actions.getEs51LandingPageList({
                action: "mbsplashpage",
                resetkey: "",
                projectid: process.env.REACT_APP_PROJECT_ID,
            })
        );
    }, [dispatch]);

    const { listLoading, es51LandingPageList } = landingPageState;

    if (listLoading && !es51LandingPageList) {
        return (
            <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.8)", zIndex: 2000 }}
            >
                <div className="spinner-border text-warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    const renderGameGrid = (title, games, isDemo = false) => {
        if (!games || games.length === 0) return null;
        return (
            <div className="mb-4">
                <div
                    className="text-warning fw-bold text-uppercase mt-3 mb-2 px-2"
                    style={{ fontSize: "14px" }}
                >
                    {title}
                </div>
                <div className="row g-2 px-2">
                    {games.map((company, idx) => (
                        <div className="col-4" key={idx}>
                            <div
                                className="bg-dark rounded text-center p-1 border border-secondary h-100 shadow-sm"
                                style={{ cursor: "pointer" }}
                                onClick={() => isDemo ? navigate(`/demo/${company.companycode || company.gamecode}`) : navigate("/login")}
                            >
                                <img
                                    src={company.iconurl}
                                    alt={company.companyname}
                                    className="img-fluid rounded w-100"
                                />
                                <div
                                    className="text-white mt-1 text-truncate"
                                    style={{ fontSize: "12px" }}
                                >
                                    {company.companyname}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const getGamesByType = (typeKey) => {
        if (!es51LandingPageList?.gameCompany?.gameTypeLists) return [];
        const category = es51LandingPageList.gameCompany.gameTypeLists.find(
            (g) => g.gametype === typeKey
        );
        return category ? category.companyLists : [];
    };

    return (
        <div
            className="container-fluid px-0 text-white overflow-hidden"
            style={{
                backgroundColor: "#0d0d0d",
                minHeight: "100vh",
                paddingBottom: "70px",
                fontFamily: "Arial, sans-serif",
            }}
        >
            {listLoading && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.8)", zIndex: 2000 }}
                >
                    <div className="spinner-border text-warning" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}

            {/* Header */}
            <div
                className="text-center py-2"
                style={{ borderBottom: "2px solid #ffcc00" }}
            >
                <img
                    src={`${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/2a.png`}
                    alt="Logo"
                    className="img-fluid"
                    style={{ maxHeight: "40px" }}
                    onClick={() => navigate("/login")}
                />
            </div>

            {/* Top Banner Carousel */}
            {es51LandingPageList?.topBannerLists?.length > 0 && (
                <Carousel
                    indicators={false}
                    controls={false}
                    interval={3000}
                    pause={false}
                    className="w-100"
                    style={{ cursor: "pointer" }}
                >
                    {es51LandingPageList.topBannerLists.map((banner, idx) => (
                        <Carousel.Item key={idx} onClick={() => navigate("/login")}>
                            <img
                                className="d-block w-100 img-fluid"
                                src={banner.imagename}
                                alt={`Banner ${idx}`}
                            />
                        </Carousel.Item>
                    ))}
                </Carousel>
            )}

            {/* Game Categories */}
            {renderGameGrid(intl.formatMessage({ id: "demo" }), es51LandingPageList?.demoCompanyLists || [], true)}
            {renderGameGrid(intl.formatMessage({ id: "slotGames" }), getGamesByType("slot"))}
            {renderGameGrid(intl.formatMessage({ id: "liveCasino" }), getGamesByType("live"))}
            {renderGameGrid(intl.formatMessage({ id: "sport" }), getGamesByType("sport"))}
            {renderGameGrid(intl.formatMessage({ id: "fishingOthers" }), getGamesByType("fishing"))}
            {renderGameGrid(intl.formatMessage({ id: "apps" }), getGamesByType("app"))}
            {renderGameGrid(intl.formatMessage({ id: "lottery" }), getGamesByType("lottery"))}

            {/* Notices/Upgrades */}
            {es51LandingPageList?.inboxists?.length > 0 && (
                <>
                    <div
                        className="text-warning fw-bold text-uppercase mt-3 mb-2 px-2"
                        style={{ fontSize: "14px" }}
                    >
                        {intl.formatMessage({ id: "noticeUpgrade" })}
                    </div>
                    {es51LandingPageList.inboxists.map((inbox, idx) => (
                        <div
                            key={idx}
                            className="bg-dark border border-warning rounded m-2 p-2 shadow"
                            onClick={() => handleInboxClick(inbox)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="text-white mb-1" style={{ fontSize: "12px" }}>
                                {inbox.title}
                            </div>
                            {inbox.imageurl && (
                                <img
                                    src={inbox.imageurl}
                                    alt={inbox.title}
                                    className="img-fluid rounded w-100"
                                />
                            )}
                        </div>
                    ))}
                </>
            )}

            {/* Winners List */}
            {es51LandingPageList?.mbDashboardRankists?.length > 0 && (
                <div className="bg-dark border border-warning rounded m-2 p-2 shadow">
                    <div
                        className="text-warning fw-bold text-center mb-2"
                        style={{ fontSize: "14px" }}
                    >
                        {intl.formatMessage({ id: "withdrawRanking" })}
                    </div>
                    <div
                        style={{ maxHeight: "150px", overflow: "hidden", fontSize: "12px" }}
                    >
                        {es51LandingPageList.mbDashboardRankists.map((rank, idx) => (
                            <div
                                key={idx}
                                className="d-flex justify-content-between mb-2 text-white"
                            >
                                <span>{rank.username || "Player***"}</span>
                                <span className="text-warning">
                                    {rank.withdrawamount || "0"}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* License Online Game */}
            <div className="bg-dark border border-warning rounded m-2 p-2 shadow">
                <div className="text-warning fw-bold mb-2">{intl.formatMessage({ id: "licenseOnlineGame" })}</div>
                <div><img
                    src={`${process.env.PUBLIC_URL}/image/landing/footer/curacao.webp`}
                    style={{ width: "100%" }}
                /></div>
            </div>

            {/* Game Provider Platform */}
            <div className="bg-dark border border-warning rounded m-2 p-2 shadow">
                <div className="text-warning fw-bold mb-2">{intl.formatMessage({ id: "gameProviderPlatform" })}</div>
                <div>
                    <div className="d-flex p-2 align-items-center text-muted">
                        <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                            <div className="mb-3" style={{ fontSize: "11px" }}>
                                {intl.formatMessage({ id: "gamingLicense" })}
                            </div>
                            <div>
                                <img
                                    src={`${process.env.PUBLIC_URL}/image/landing/footer/gamecert1.webp`}
                                    style={{ height: "50px" }}
                                />
                                <img
                                    src={`${process.env.PUBLIC_URL}/image/landing/footer/gamecert2.webp`}
                                    style={{ height: "50px" }}
                                />
                            </div>
                        </div>
                        <div style={{ fontSize: "10px" }}>
                            {intl.formatMessage(
                                { id: "landingFooter1" },
                                { X: process.env.REACT_APP_SHORT_NAME }
                            )}
                        </div>
                    </div>
                    <div className="border-bottom"></div>
                    <div className="d-flex p-2 align-items-center text-muted">
                        <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                            <div className="mb-3" style={{ fontSize: "11px" }}>
                                {intl.formatMessage({ id: "gamingLicense" })}
                            </div>
                            <img
                                src={`${process.env.PUBLIC_URL}/image/landing/footer/pagcor.webp`}
                                style={{ width: "80%" }}
                            />
                        </div>
                        <div style={{ fontSize: "10px" }}>
                            {intl.formatMessage({ id: "landingFooter2" })}
                        </div>
                    </div>
                </div>
            </div>

            {/* Payment Methods */}
            <div className="bg-dark border border-warning rounded m-2 p-2 shadow">
                <div className="text-warning fw-bold mb-2">{intl.formatMessage({ id: "paymentMethod" })}</div>
                <div className="d-flex flex-wrap gap-2">
                    {[...Array(13)].map((_, idx) => (
                        <img
                            key={idx}
                            src={`${process.env.PUBLIC_URL}/image/landing/bankLogo/Image (${idx + 1}).webp`}
                            alt="Bank"
                            className="bg-white rounded p-1"
                            style={{ height: "25px" }}
                            onError={(e) => (e.target.style.display = "none")}
                        />
                    ))}
                </div>
            </div>

            {/* Browser */}
            <div className="bg-dark border border-warning rounded m-2 p-2 shadow">
                <div className="text-warning fw-bold mb-2">{intl.formatMessage({ id: "browserCooperatives" })}</div>
                <div className="d-flex gap-2">
                    {[...Array(5)].map((_, idx) => (
                        <img
                            key={idx}
                            src={`${process.env.PUBLIC_URL}/image/landing/browser/${idx + 1}.webp`}
                            alt="Browser"
                            className="bg-white rounded p-1"
                            style={{ height: "25px" }}
                            onError={(e) => (e.target.style.display = "none")}
                        />
                    ))}
                </div>
            </div>

            {/* Inbox Detail Modal */}
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton closeVariant="white" className="bg-dark border-warning border-bottom">
                    <Modal.Title className="text-warning fw-bold" style={{ fontSize: "16px" }}>
                        {selectedInbox?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-white">
                    {selectedInbox?.imageurl && (
                        <img
                            src={selectedInbox.imageurl}
                            alt={selectedInbox.title}
                            className="img-fluid rounded w-100 mb-3"
                        />
                    )}
                    <div style={{ whiteSpace: "pre-wrap", fontSize: "14px", lineHeight: "1.5" }}>
                        {selectedInbox?.content}
                    </div>
                </Modal.Body>
            </Modal>

            {/* Sticky Bottom Bar */}
            <div className="fixed-bottom d-flex w-100" style={{ zIndex: 1000 }}>
                <button
                    className="btn w-50 fw-bold rounded-0 d-flex align-items-center justify-content-center gap-2"
                    style={{
                        backgroundColor: "#ff6666",
                        color: "#fff",
                        padding: "15px 0",
                    }}
                    onClick={() => navigate("/login")}
                >
                    <LuUser size={20} />
                    {intl.formatMessage({ id: "login" })}
                </button>
                <button
                    className="btn w-50 fw-bold rounded-0 d-flex align-items-center justify-content-center gap-2"
                    style={{
                        backgroundColor: "#33cccc",
                        color: "#fff",
                        padding: "15px 0",
                    }}
                    onClick={() => navigate("/register")}
                >
                    <LuUserPlus size={20} />
                    {intl.formatMessage({ id: "register" })}
                </button>
            </div>
        </div>
    );
};
